import { Api, Hooks } from '@3nickels/data-modules';
import { useService } from '@aesop-fables/containr-react';
import { useEffect, useState } from 'react';

const useDocs = () => {
  const [terms, setTerms] = useState<string>('');
  const [disclosure, setDisclosure] = useState<string>('');
  const [privacyPolicy, setPrivacyPolicy] = useState<string>('');
  const termsApi = useService<Api.TermsAndConditionsApi>(Api.ApiKeys.TermsAndConditions);

  const docs = Hooks.useTermsAndConditionsDocs();

  useEffect(() => {
    if (docs) {
      docs.forEach((doc) => {
        const url = termsApi.getDocString(doc.id);
        if (doc.docDescription === 'Terms of Service') {
          setTerms(url);
        } else if (doc.docDescription === 'Disclosure') {
          setDisclosure(url);
        } else if (doc.docDescription === 'Privacy Policy') {
          setPrivacyPolicy(url);
        }
      });
    }
  }, [docs, termsApi]);

  // The AI Disclaimer is an in-app route rather than a hosted document.
  return { terms, disclosure, privacyPolicy, aiDisclaimer: '/ai-disclaimer' };
};

export default useDocs;
